<template>
  <div class="news_list_page">
    <div class="news_wrap">
      <div class="news_tit">{{ $t('news.title') }}</div>
      <div class="news_detail">
        <div
          class="news_item"
          v-for="(item, index) in newsList"
          :key="index"
          @click="handleToNewsDetails(index)"
        >
          <div class="news_item_util">
            <div class="news_item_title">{{ item.newPlate }}</div>
            <div class="bottom_wrap">
              <div class="bottom_left">
                <img :src="item.imageSrc" alt="" />
              </div>
              <div class="bottom_right">
                <div class="right_desc">{{ item.newDetail }}</div>
                <router-link class="right_btn" :to="item.router">
                  {{ $t('more') }} >>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsList',
  computed: {
    newsList() {
      return [
        {
          newPlate: this.$t('news.items[0].plate'),
          imageSrc:
            'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80',
          newTitle: this.$t('news.items[0].title'),
          newDetail: this.$t('news.items[0].desc'),
          router: '/news_detail/1'
        },
        {
          newPlate: this.$t('news.items[1].plate'),
          imageSrc:
            'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=800&q=80',
          newTitle: this.$t('news.items[1].title'),
          newDetail: this.$t('news.items[1].desc'),
          router: '/news_detail/2'
        },
        {
          newPlate: this.$t('news.items[2].plate'),
          imageSrc:
            'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=800&q=80',
          newTitle: this.$t('news.items[2].title'),
          newDetail: this.$t('news.items[2].desc'),
          router: '/news_detail/3'
        },
        {
          newPlate: this.$t('news.items[3].plate'),
          imageSrc:
            'https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=800&q=80',
          newTitle: this.$t('news.items[3].title'),
          newDetail: this.$t('news.items[3].desc'),
          router: '/news_detail/4'
        },
              {
          newPlate: this.$t('news.items[4].plate'),
          imageSrc:
            'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?auto=format&fit=crop&w=800&q=80',
          newTitle: this.$t('news.items[4].title'),
          newDetail: this.$t('news.items[4].desc'),
          router: '/news_detail/5'
        }
      ]
    }
  },
  methods: {
    handleToNewsDetails(index) {
      if (index === 0) {
        this.$router.push('/news_detail/1')
      } else if (index === 1) {
        this.$router.push('/news_detail/2')
      } else if (index === 2) {
        this.$router.push('/news_detail/3')
      } else if (index === 3) {
        this.$router.push('/news_detail/4')
      }else   {
        this.$router.push('/news_detail/5')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.news_list_page {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.news_wrap {
  width: 100%;
  padding: 80px 0 70px;
  text-align: center;
}

.news_tit {
  font-size: 2.2rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 36px;
}

.news_detail {
  display: grid;
  grid-template-columns: 1fr;
  gap: 28px;
  width: 90%;
  margin: 0 auto;
  max-width: 980px;
}

.news_item {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.08),
    0 2px 4px -2px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
      0 8px 10px -6px rgba(0, 0, 0, 0.1);
    .bottom_left img {
      transform: scale(1.05);
    }
  }
}

.news_item_util {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.news_item_title {
  width: 100%;
  padding: 18px 22px;
  background: linear-gradient(135deg, #0b2f5f 0%, #0b4a8a 55%, #0a6bb8 100%);
  color: #f8fafc;
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.35;
  text-align: left;
  letter-spacing: 0.2px;
}

.bottom_wrap {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
}

.bottom_left {
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }
}

.bottom_right {
  padding: 18px 22px 24px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  text-align: left;
}

.right_desc {
  font-size: 0.95rem;
  color: #4a5568;
  line-height: 1.6;
  margin-bottom: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
}

.right_btn {
  display: inline-block;
  background: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
  font-size: 0.85rem;
  font-weight: 600;
  padding: 8px 18px;
  color: #fff;
  border-radius: 999px;
  text-decoration: none;
  margin-top: auto;
  align-self: flex-end;
  transition: all 0.3s ease;

  &:hover {
    filter: brightness(1.1);
    box-shadow: 0 4px 15px rgba(10, 127, 215, 0.4);
    transform: translateY(-2px);
  }
}

@media screen and (min-width: 1024px) {
  .news_tit {
    font-size: 2.5rem;
  }
}
</style>
